import { render, staticRenderFns } from "./ChooseNationalityMulti.vue?vue&type=template&id=3d6d26d0&scoped=true"
import script from "./ChooseNationalityMulti.vue?vue&type=script&lang=js"
export * from "./ChooseNationalityMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6d26d0",
  null
  
)

export default component.exports